export const VISITED_COOKIE = 'visited-ti4-score-already';

export const setVisitedCookie = () =>
  localStorage.setItem(VISITED_COOKIE, 'true');
export const hasVisited = () => !!localStorage.getItem(VISITED_COOKIE);
